export default function () {
    return (
        <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7177_94528)">
                <path
                    d="M22.8 3.5H9.2C8.53726 3.5 8 4.03726 8 4.7V28.3C8 28.9627 8.53726 29.5 9.2 29.5H22.8C23.4627 29.5 24 28.9627 24 28.3V4.7C24 4.03726 23.4627 3.5 22.8 3.5Z"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 6.5L18 6.5" stroke="black" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M17.5 26C17.5 26.8284 16.8284 27.5 16 27.5C15.1716 27.5 14.5 26.8284 14.5 26C14.5 25.1716 15.1716 24.5 16 24.5C16.8284 24.5 17.5 25.1716 17.5 26Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_7177_94528">
                    <rect width="32" height="32" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
